var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.819,
    height: 20.085,
    viewBox: "0 0 46.819 20.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1242",
    "data-name": "Rectangle 1242",
    width: 46.819,
    height: 20.085,
    fill: "#3d3d3d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1680",
    "data-name": "Group 1680",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47698",
    "data-name": "Path 47698",
    d: "M73.929,145.667a4.158,4.158,0,1,0,4.158,4.158,4.158,4.158,0,0,0-4.158-4.158m0,6.853a2.711,2.711,0,1,1,2.711-2.711,2.711,2.711,0,0,1-2.711,2.711",
    transform: "translate(-64.134 -133.899)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47699",
    "data-name": "Path 47699",
    d: "M46.8,12.685a3.173,3.173,0,0,0-.757-1.9,9.364,9.364,0,0,1-.941-1.148,9.685,9.685,0,0,0-4.114-2.785,25.01,25.01,0,0,0-4.917-1.182c-.3-.045-.93-.166-1.18-.22-.142-.107-.435-.342-.7-.553-.674-.539-1.6-1.278-2.157-1.65a31.408,31.408,0,0,0-2.989-1.7A13.1,13.1,0,0,0,25.774.425a27.566,27.566,0,0,0-6-.4,20.042,20.042,0,0,0-7.23,1.524A16.168,16.168,0,0,0,7.6,4.662a23.546,23.546,0,0,0-1.881,2c-.188.215-.41.47-.545.616l-.1.023A8.033,8.033,0,0,0,1.933,8.568a4.337,4.337,0,0,0-1.759,2.87c-.015.07-.03.139-.045.2A10.136,10.136,0,0,0,0,13.294v.213a4.739,4.739,0,0,0,.824,3.282,4.022,4.022,0,0,0,2.295,1.077c.215.045.8.1,1.6.154a5.461,5.461,0,0,1-.385-1.525c-.461-.035-.784-.067-.908-.093a2.971,2.971,0,0,1-1.472-.6A3.56,3.56,0,0,1,1.5,13.513v-.219a8.368,8.368,0,0,1,.09-1.316c.017-.074.033-.15.05-.229a2.875,2.875,0,0,1,1.2-1.991,6.73,6.73,0,0,1,2.548-.993A1.321,1.321,0,0,0,6.071,8.5c.139-.125.361-.378.773-.85A23.436,23.436,0,0,1,8.574,5.8a14.712,14.712,0,0,1,4.545-2.868,18.629,18.629,0,0,1,6.72-1.412c.351-.015.7-.021,1.036-.021a25.823,25.823,0,0,1,4.6.395,11.533,11.533,0,0,1,2.887.988A30.26,30.26,0,0,1,31.214,4.5c.5.335,1.4,1.05,2.049,1.571.829.664.9.715,1.048.774.208.083,1.364.284,1.547.311a23.515,23.515,0,0,1,4.619,1.106,8.336,8.336,0,0,1,3.412,2.25A10.788,10.788,0,0,0,44.949,11.8l.005.006a1.692,1.692,0,0,1,.36,1,3.726,3.726,0,0,1,0,.486c0,.115-.009.233-.009.363a3.678,3.678,0,0,1-.248,1.444,1.643,1.643,0,0,1-1.108.909l-.074.025a5.481,5.481,0,0,1-.282,1.617,6.937,6.937,0,0,0,.863-.235,3.142,3.142,0,0,0,1.982-1.742,5.108,5.108,0,0,0,.362-2.018c0-.109,0-.209.008-.3a5.083,5.083,0,0,0-.006-.671",
    transform: "translate(0 0)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47700",
    "data-name": "Path 47700",
    d: "M199.89,210.7c-.565.017-.958.024-1.094.024H182.12a5.47,5.47,0,0,1-.536,1.475l.534.021H198.8c.024,0,.655-.011,1.631-.042a5.467,5.467,0,0,1-.536-1.479",
    transform: "translate(-166.914 -193.681)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47701",
    "data-name": "Path 47701",
    d: "M427.437,145.463a4.158,4.158,0,1,0,4.158,4.158,4.158,4.158,0,0,0-4.158-4.158m0,6.853a2.711,2.711,0,1,1,2.711-2.711,2.711,2.711,0,0,1-2.711,2.711",
    transform: "translate(-389.082 -133.711)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47702",
    "data-name": "Path 47702",
    d: "M155.029,41.029l-.057.014a12.222,12.222,0,0,0-3.991,1.612,15.036,15.036,0,0,0-2.063,1.642.9.9,0,0,0-.361.813.487.487,0,0,0,.478.326c.181.014,5.4.1,5.525.1.1,0,.17.006.431.008a.372.372,0,0,0,.237-.092.368.368,0,0,0,.116-.242c0-.145.075-2.775.106-3.831a.361.361,0,0,0-.42-.351",
    transform: "translate(-136.539 -37.708)",
    fill: "#4cbd01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47703",
    "data-name": "Path 47703",
    d: "M274.788,40.865a14.9,14.9,0,0,0-4.288-2.8,11.647,11.647,0,0,0-4.593-.943c-.229-.005-.383-.014-.649-.017a.34.34,0,0,0-.235.106.349.349,0,0,0-.1.245v4.152a.35.35,0,0,0,.351.351c3.389,0,7.923.027,8.9.03a3.857,3.857,0,0,0,.479-.022.5.5,0,0,0,.48-.38,1.064,1.064,0,0,0-.344-.725",
    transform: "translate(-243.52 -34.11)",
    fill: "#4cbd01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyCar);
export default __webpack_public_path__ + "static/media/policy-car.5e38ed0657ec713ff4d4fc1caf695eed.svg";
export { ForwardRef as ReactComponent };